export interface CityData {
  name: string;
  lat: number;
  lng: number;
}

export interface LocationData {
  slug: string;
  name: string;
  state: string;
  region: string;
  description: string;
  highlights: string[];
  content: string[];
  isPrimary: boolean;
  lat: number;
  lng: number;
  cities: CityData[];
}

export const locations: LocationData[] = [
  {
    slug: "tampa",
    name: "Tampa",
    state: "FL",
    region: "Hillsborough County",
    isPrimary: true,
    lat: 27.9506,
    lng: -82.4572,
    description:
      "JR Pro Cleaning Services is proudly based in Tampa, delivering house cleaning, deep cleaning, and commercial cleaning across the entire city — from South Tampa to New Tampa and everywhere in between.",
    highlights: [
      "Locally owned & operated in Tampa",
      "House, deep & commercial cleaning",
      "Airbnb turnovers across the city",
      "Mon–Sat availability, 8 AM – 6 PM",
    ],
    content: [
      "Tampa is home for JR Pro Cleaning Services. From Hyde Park bungalows and Seminole Heights craftsman homes to downtown condos and New Tampa family houses, our team cleans every kind of property this city has to offer. Being based here means fast scheduling, familiar faces, and a team that treats your home like a neighbor's — because it is.",
      "We provide the full range of our services throughout Tampa: residential house cleaning, deep cleaning, recurring standard cleaning, move-in/move-out cleaning, Airbnb and vacation rental turnovers, post-construction cleaning, upholstery and furniture cleaning, and carpet, rug, and tile care.",
      "Beyond Tampa itself, we serve the wider bay area including Clearwater, St. Petersburg, Brandon, Wesley Chapel, and more — also serving Dunedin, Largo, Pinellas Park, Safety Harbor, and Apollo Beach. Call (978) 564-5018 for a free estimate anywhere in the Tampa Bay area.",
    ],
    cities: [
      { name: "Clearwater", lat: 27.9659, lng: -82.8001 },
      { name: "St. Petersburg", lat: 27.7676, lng: -82.6403 },
      { name: "Brandon", lat: 27.9378, lng: -82.2859 },
      { name: "Riverview", lat: 27.8661, lng: -82.3265 },
      { name: "Wesley Chapel", lat: 28.2397, lng: -82.3277 },
      { name: "Lutz", lat: 28.1511, lng: -82.4615 },
      { name: "Oldsmar", lat: 28.0342, lng: -82.6651 },
      { name: "Carrollwood", lat: 28.0508, lng: -82.5062 },
      { name: "Temple Terrace", lat: 28.0353, lng: -82.3893 },
      { name: "Valrico", lat: 27.9459, lng: -82.2364 },
      { name: "Plant City", lat: 28.0186, lng: -82.1129 },
      { name: "Land O' Lakes", lat: 28.2189, lng: -82.4576 },
      { name: "Palm Harbor", lat: 28.0781, lng: -82.7637 },
    ],
  },
  {
    slug: "clearwater",
    name: "Clearwater",
    state: "FL",
    region: "Pinellas County",
    isPrimary: false,
    lat: 27.9659,
    lng: -82.8001,
    description:
      "Professional house cleaning, deep cleaning, and vacation rental turnovers in Clearwater — from Clearwater Beach condos to family homes in Countryside.",
    highlights: [
      "Beach condo & rental turnovers",
      "Recurring cleaning plans",
      "Deep cleaning specialists",
      "Free estimates in Clearwater",
    ],
    content: [
      "Clearwater's mix of beachfront condos, vacation rentals, and established neighborhoods keeps our team busy year-round. Whether you need a weekly clean for your Countryside home or fast, reliable turnovers for a Clearwater Beach rental, JR Pro Cleaning Services delivers the same detail-driven standard on every visit.",
      "Vacation rental owners in Clearwater trust us for photo-ready staging, linen changes, and restocking between guests — with flexible scheduling built around your booking calendar. Homeowners count on us for deep cleans, recurring service, and move-in/move-out cleanings that protect deposits.",
      "We also serve nearby Dunedin, Largo, Safety Harbor, and Pinellas Park. Call (978) 564-5018 for a free Clearwater estimate.",
    ],
    cities: [
      { name: "Clearwater Beach", lat: 27.9775, lng: -82.8271 },
      { name: "Countryside", lat: 28.0339, lng: -82.7287 },
      { name: "Dunedin", lat: 28.0198, lng: -82.7718 },
      { name: "Safety Harbor", lat: 28.0089, lng: -82.6931 },
      { name: "Largo", lat: 27.9095, lng: -82.7873 },
      { name: "Belleair", lat: 27.9358, lng: -82.8082 },
    ],
  },
  {
    slug: "st-petersburg",
    name: "St. Petersburg",
    state: "FL",
    region: "Pinellas County",
    isPrimary: false,
    lat: 27.7676,
    lng: -82.6403,
    description:
      "Trusted residential and commercial cleaning in St. Petersburg — downtown condos, historic Old Northeast homes, and offices across the city.",
    highlights: [
      "Downtown condo cleaning",
      "Office & commercial service",
      "Move-in/move-out specialists",
      "Airbnb turnover service",
    ],
    content: [
      "St. Petersburg's booming downtown, historic neighborhoods, and growing rental market all demand different kinds of clean — and JR Pro Cleaning Services handles them all. We clean high-rise condos along Beach Drive, bungalows in Kenwood and Old Northeast, and offices and storefronts throughout the city.",
      "Landlords and property managers in St. Pete rely on our move-in/move-out cleanings between tenants, while Airbnb hosts use our turnover service to keep five-star cleanliness scores. Homeowners choose weekly or bi-weekly recurring plans that keep life simple.",
      "We also serve nearby Pinellas Park and Largo. Call (978) 564-5018 for a free St. Petersburg estimate.",
    ],
    cities: [
      { name: "Downtown St. Pete", lat: 27.7712, lng: -82.6367 },
      { name: "Old Northeast", lat: 27.7885, lng: -82.6318 },
      { name: "Kenwood", lat: 27.7726, lng: -82.6614 },
      { name: "Pinellas Park", lat: 27.8428, lng: -82.6995 },
      { name: "Gulfport", lat: 27.7481, lng: -82.7037 },
      { name: "Snell Isle", lat: 27.7902, lng: -82.6198 },
    ],
  },
  {
    slug: "brandon",
    name: "Brandon",
    state: "FL",
    region: "Hillsborough County",
    isPrimary: false,
    lat: 27.9378,
    lng: -82.2859,
    description:
      "Reliable house cleaning and deep cleaning for Brandon families — flexible scheduling for busy households east of Tampa.",
    highlights: [
      "Family home cleaning experts",
      "Weekly & bi-weekly plans",
      "Deep cleaning & carpet care",
      "Fast scheduling in Brandon",
    ],
    content: [
      "Brandon's family neighborhoods are the heart of our east Hillsborough service area. Busy households throughout Brandon, Bloomingdale, and Providence Lakes count on JR Pro Cleaning Services for recurring cleanings that keep up with real life — kids, pets, and all.",
      "Our deep cleaning service is a favorite here for seasonal resets and pre-holiday preparation, and our carpet and upholstery cleaning tackles the wear and tear that family homes actually experience.",
      "We also serve neighboring Valrico, Riverview, and Seffner. Call (978) 564-5018 for a free Brandon estimate.",
    ],
    cities: [
      { name: "Bloomingdale", lat: 27.8936, lng: -82.2404 },
      { name: "Providence Lakes", lat: 27.9106, lng: -82.3121 },
      { name: "Seffner", lat: 27.9836, lng: -82.2756 },
      { name: "Valrico", lat: 27.9459, lng: -82.2364 },
      { name: "Riverview", lat: 27.8661, lng: -82.3265 },
    ],
  },
  {
    slug: "riverview",
    name: "Riverview",
    state: "FL",
    region: "Hillsborough County",
    isPrimary: false,
    lat: 27.8661,
    lng: -82.3265,
    description:
      "House cleaning and move-in/move-out service in fast-growing Riverview — perfect for new-construction homes and busy commuter families.",
    highlights: [
      "New-construction cleaning",
      "Move-in/move-out experts",
      "Recurring family plans",
      "Post-construction service",
    ],
    content: [
      "Riverview is one of the fastest-growing communities in the Tampa Bay area, and JR Pro Cleaning Services grows with it. New homeowners throughout Riverview, Winthrop, and South Fork call us for move-in cleanings and post-construction dust removal that builders leave behind.",
      "Once you're settled, our recurring cleaning plans keep your home guest-ready without adding another task to your commute-packed week.",
      "We also serve nearby Apollo Beach, Gibsonton, and Brandon. Call (978) 564-5018 for a free Riverview estimate.",
    ],
    cities: [
      { name: "Winthrop", lat: 27.8905, lng: -82.3145 },
      { name: "South Fork", lat: 27.7973, lng: -82.3452 },
      { name: "Gibsonton", lat: 27.8536, lng: -82.3826 },
      { name: "Apollo Beach", lat: 27.7731, lng: -82.4076 },
      { name: "Boyette", lat: 27.8511, lng: -82.2884 },
    ],
  },
  {
    slug: "wesley-chapel",
    name: "Wesley Chapel",
    state: "FL",
    region: "Pasco County",
    isPrimary: false,
    lat: 28.2397,
    lng: -82.3277,
    description:
      "Premium house cleaning and deep cleaning in Wesley Chapel — serving Seven Oaks, Meadow Pointe, Epperson, and beyond.",
    highlights: [
      "Master-planned community service",
      "Deep cleaning specialists",
      "Recurring cleaning plans",
      "New-home move-in cleans",
    ],
    content: [
      "Wesley Chapel's master-planned communities — Seven Oaks, Meadow Pointe, Epperson, and Watergrass — are filled with beautiful newer homes that deserve professional care. JR Pro Cleaning Services provides detailed recurring cleaning, deep cleans, and move-in service throughout the area.",
      "Homeowners here love our attention to the details that make newer homes shine: sparkling kitchens, streak-free glass, and floors that look the way they did on closing day.",
      "We also serve nearby Land O' Lakes, Lutz, and New Tampa. Call (978) 564-5018 for a free Wesley Chapel estimate.",
    ],
    cities: [
      { name: "Seven Oaks", lat: 28.1963, lng: -82.3629 },
      { name: "Meadow Pointe", lat: 28.1937, lng: -82.3159 },
      { name: "Epperson", lat: 28.2814, lng: -82.2865 },
      { name: "Watergrass", lat: 28.2668, lng: -82.2934 },
      { name: "Zephyrhills", lat: 28.2336, lng: -82.1812 },
    ],
  },
  {
    slug: "lutz",
    name: "Lutz",
    state: "FL",
    region: "Hillsborough County",
    isPrimary: false,
    lat: 28.1511,
    lng: -82.4615,
    description:
      "Dependable house cleaning in Lutz — lakefront homes, established neighborhoods, and new communities alike.",
    highlights: [
      "Lakefront home cleaning",
      "Deep & standard cleaning",
      "Upholstery & carpet care",
      "Trusted local team",
    ],
    content: [
      "Lutz blends old-Florida charm with newer development, and our cleaning service adapts to both. From lakefront properties off Dale Mabry to newer homes near the Veterans Expressway, JR Pro Cleaning Services delivers consistent, detail-focused cleaning on every visit.",
      "Our upholstery and carpet cleaning services are popular with Lutz homeowners maintaining larger properties, and our recurring plans keep busy households effortlessly clean.",
      "We also serve nearby Land O' Lakes, Carrollwood, and Wesley Chapel. Call (978) 564-5018 for a free Lutz estimate.",
    ],
    cities: [
      { name: "Cheval", lat: 28.1451, lng: -82.5205 },
      { name: "Land O' Lakes", lat: 28.2189, lng: -82.4576 },
      { name: "Carrollwood", lat: 28.0508, lng: -82.5062 },
      { name: "Odessa", lat: 28.1936, lng: -82.5915 },
      { name: "Northdale", lat: 28.1055, lng: -82.5257 },
    ],
  },
  {
    slug: "oldsmar",
    name: "Oldsmar",
    state: "FL",
    region: "Pinellas County",
    isPrimary: false,
    lat: 28.0342,
    lng: -82.6651,
    description:
      "House and office cleaning in Oldsmar — where Tampa Bay's counties meet, our team is right around the corner.",
    highlights: [
      "Residential & office cleaning",
      "Move-in/move-out service",
      "Flexible scheduling",
      "Quick response times",
    ],
    content: [
      "Sitting at the crossroads of Hillsborough and Pinellas counties, Oldsmar is minutes from our Tampa base — which means fast scheduling and reliable service for both homes and businesses.",
      "We clean family homes throughout East Lake Woodlands and central Oldsmar, and provide commercial cleaning for the offices and light-industrial businesses that call Oldsmar home.",
      "We also serve nearby Safety Harbor, Westchase, and Palm Harbor. Call (978) 564-5018 for a free Oldsmar estimate.",
    ],
    cities: [
      { name: "East Lake Woodlands", lat: 28.0625, lng: -82.6926 },
      { name: "Westchase", lat: 28.0578, lng: -82.6113 },
      { name: "Safety Harbor", lat: 28.0089, lng: -82.6931 },
      { name: "Town 'n' Country", lat: 28.0106, lng: -82.5768 },
      { name: "Palm Harbor", lat: 28.0781, lng: -82.7637 },
    ],
  },
  {
    slug: "carrollwood",
    name: "Carrollwood",
    state: "FL",
    region: "Hillsborough County",
    isPrimary: false,
    lat: 28.0508,
    lng: -82.5062,
    description:
      "Detailed house cleaning in Carrollwood and Carrollwood Village — one of our most popular service areas, just north of Tampa.",
    highlights: [
      "Carrollwood Village specialists",
      "Weekly & bi-weekly plans",
      "Deep cleaning & appliance care",
      "Minutes from our home base",
    ],
    content: [
      "Carrollwood's tree-lined streets and established homes are some of our favorite properties to clean. JR Pro Cleaning Services provides recurring cleaning, deep cleans, and appliance detailing throughout Carrollwood, Carrollwood Village, and Original Carrollwood.",
      "Being minutes from our Tampa base means Carrollwood clients enjoy the fastest scheduling in our service area — including same-week deep cleans when life demands it.",
      "We also serve nearby Northdale, Lake Magdalene, and Citrus Park. Call (978) 564-5018 for a free Carrollwood estimate.",
    ],
    cities: [
      { name: "Carrollwood Village", lat: 28.0664, lng: -82.5205 },
      { name: "Original Carrollwood", lat: 28.0442, lng: -82.4938 },
      { name: "Northdale", lat: 28.1055, lng: -82.5257 },
      { name: "Lake Magdalene", lat: 28.0847, lng: -82.4793 },
      { name: "Citrus Park", lat: 28.0784, lng: -82.5701 },
    ],
  },
  {
    slug: "temple-terrace",
    name: "Temple Terrace",
    state: "FL",
    region: "Hillsborough County",
    isPrimary: false,
    lat: 28.0353,
    lng: -82.3893,
    description:
      "House cleaning and rental turnover service in Temple Terrace — golf-course homes, family neighborhoods, and USF-area rentals.",
    highlights: [
      "Golf-course community cleaning",
      "USF-area rental turnovers",
      "Move-in/move-out cleaning",
      "Recurring service plans",
    ],
    content: [
      "Temple Terrace's riverside golf community and its proximity to USF make for a unique mix of properties — and JR Pro Cleaning Services cleans them all. Established homes along the Hillsborough River get our detailed deep cleans, while rental owners near campus rely on our fast move-in/move-out turnovers between tenants.",
      "Landlords appreciate our deposit-inspection-ready detail work; families appreciate a recurring plan that keeps the house clean through busy semesters.",
      "We also serve nearby New Tampa, Thonotosassa, and East Tampa. Call (978) 564-5018 for a free Temple Terrace estimate.",
    ],
    cities: [
      { name: "USF Area", lat: 28.0587, lng: -82.4139 },
      { name: "New Tampa", lat: 28.1276, lng: -82.3671 },
      { name: "Thonotosassa", lat: 28.0614, lng: -82.3018 },
      { name: "East Lake-Orient Park", lat: 27.9964, lng: -82.3787 },
    ],
  },
  {
    slug: "valrico",
    name: "Valrico",
    state: "FL",
    region: "Hillsborough County",
    isPrimary: false,
    lat: 27.9459,
    lng: -82.2364,
    description:
      "Trusted residential cleaning in Valrico — recurring plans, deep cleans, and floor care for east Hillsborough families.",
    highlights: [
      "Family home specialists",
      "Carpet & tile cleaning",
      "Deep cleaning resets",
      "Reliable scheduling",
    ],
    content: [
      "Valrico's quiet subdivisions — Buckhorn, Bloomingdale East, and River Hills — are full of well-kept family homes, and JR Pro Cleaning Services helps keep them that way. Our recurring cleaning plans handle the weekly upkeep while seasonal deep cleans reset the details.",
      "Valrico homeowners also trust us for carpet, rug, and tile care — especially pet odor treatment and grout restoration in Florida's high-humidity conditions.",
      "We also serve nearby Brandon, Lithia, and Plant City. Call (978) 564-5018 for a free Valrico estimate.",
    ],
    cities: [
      { name: "Buckhorn", lat: 27.9188, lng: -82.2534 },
      { name: "River Hills", lat: 27.9004, lng: -82.2202 },
      { name: "Lithia", lat: 27.8434, lng: -82.1793 },
      { name: "Dover", lat: 27.9942, lng: -82.2198 },
      { name: "FishHawk", lat: 27.8508, lng: -82.2110 },
    ],
  },
  {
    slug: "plant-city",
    name: "Plant City",
    state: "FL",
    region: "Hillsborough County",
    isPrimary: false,
    lat: 28.0186,
    lng: -82.1129,
    description:
      "Professional house and commercial cleaning in Plant City — honest, detail-driven service for the winter strawberry capital.",
    highlights: [
      "House & commercial cleaning",
      "Deep cleaning service",
      "Move-in/move-out cleans",
      "Small-town service values",
    ],
    content: [
      "Plant City may be famous for strawberries, but for us it's a community of hardworking families and local businesses that value honest, reliable service. JR Pro Cleaning Services brings the same detail-driven cleaning to Plant City homes that we deliver across Tampa Bay.",
      "From historic downtown homes to newer subdivisions, our team handles standard cleanings, deep cleans, and the move-in/move-out details that make transitions easier. Local businesses count on our commercial cleaning to keep storefronts and offices presentable.",
      "We also serve nearby Dover, Seffner, and Valrico. Call (978) 564-5018 for a free Plant City estimate.",
    ],
    cities: [
      { name: "Historic Downtown", lat: 28.0164, lng: -82.1276 },
      { name: "Walden Lake", lat: 27.9975, lng: -82.1443 },
      { name: "Dover", lat: 27.9942, lng: -82.2198 },
      { name: "Seffner", lat: 27.9836, lng: -82.2756 },
    ],
  },
  {
    slug: "land-o-lakes",
    name: "Land O' Lakes",
    state: "FL",
    region: "Pasco County",
    isPrimary: false,
    lat: 28.2189,
    lng: -82.4576,
    description:
      "House cleaning and deep cleaning in Land O' Lakes — serving Connerton, Ballantrae, and lake communities across central Pasco.",
    highlights: [
      "Lake community cleaning",
      "Recurring cleaning plans",
      "Deep cleans & floor care",
      "New-home move-in service",
    ],
    content: [
      "Land O' Lakes combines lakefront living with fast-growing family communities like Connerton and Ballantrae — and JR Pro Cleaning Services covers it all. Our recurring plans keep busy households consistently clean, while our deep cleaning service handles seasonal resets and special occasions.",
      "New construction throughout central Pasco also keeps our move-in cleaning and post-construction teams busy, making sure new homes are actually clean before families settle in.",
      "We also serve nearby Lutz, Wesley Chapel, and Odessa. Call (978) 564-5018 for a free Land O' Lakes estimate.",
    ],
    cities: [
      { name: "Connerton", lat: 28.2846, lng: -82.4620 },
      { name: "Ballantrae", lat: 28.1889, lng: -82.5065 },
      { name: "Lake Padgett", lat: 28.2276, lng: -82.4380 },
      { name: "Odessa", lat: 28.1936, lng: -82.5915 },
      { name: "Lutz", lat: 28.1511, lng: -82.4615 },
    ],
  },
  {
    slug: "palm-harbor",
    name: "Palm Harbor",
    state: "FL",
    region: "Pinellas County",
    isPrimary: false,
    lat: 28.0781,
    lng: -82.7637,
    description:
      "Detailed residential cleaning in Palm Harbor — from Ozona cottages to Lansbrook family homes and everything between.",
    highlights: [
      "Coastal home cleaning",
      "Deep cleaning specialists",
      "Vacation rental turnovers",
      "Upholstery & carpet care",
    ],
    content: [
      "Palm Harbor rounds out the northern edge of our Pinellas service area with a wonderful mix of coastal cottages, golf-course communities, and established family neighborhoods. JR Pro Cleaning Services provides the full menu here: standard and deep cleaning, vacation rental turnovers, and upholstery and floor care.",
      "Homes near the water especially benefit from our regular deep cleans — salt air and humidity are tough on surfaces, and consistent professional care keeps them looking their best.",
      "We also serve nearby Dunedin, Safety Harbor, and East Lake. Call (978) 564-5018 for a free Palm Harbor estimate.",
    ],
    cities: [
      { name: "Ozona", lat: 28.0645, lng: -82.7818 },
      { name: "Crystal Beach", lat: 28.0903, lng: -82.7801 },
      { name: "Lansbrook", lat: 28.1085, lng: -82.7107 },
      { name: "East Lake", lat: 28.1109, lng: -82.6949 },
      { name: "Dunedin", lat: 28.0198, lng: -82.7718 },
    ],
  },
];
